import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { CustomMessageService } from './custom.message.service';
import * as ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { AppConstants } from '../shared/appconstants';
import { GridApi } from 'ag-grid-community';
import { HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class CommonService {  
  constructor(private apiService: ApiService, public customMessageService: CustomMessageService) {}
   downloadExcelFileAPI(agGridApi?: GridApi, additionalColumns?: string[], selected? : boolean, isExcelWithValidation : boolean = false, legend?: any, headerMap?: any){  
     this.apiService.downloadExcelWithMipLabelsAPI(agGridApi, additionalColumns, selected, isExcelWithValidation, legend, headerMap).subscribe((response: any) => {
      if (response) { 
        const blob = new Blob([response], { type: 'application/ms-excel' });
        const link = document.createElement('a');
        link.style.display = 'none';
        link.href = window.URL.createObjectURL(blob);     
        let fileName = "PCM_" + this.customMessageService.getDateString(new Date()) + ".xlsx";
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        setTimeout(function () {
          document.body.removeChild(link);
          window.URL.revokeObjectURL(link.href);
        }, 100);
      }
    });
  }

  public downloadExcelFile(agGridApi?: GridApi, onlySelected: boolean = false) {
    let colums = agGridApi.getAllDisplayedColumns().filter((p: any) => p.colId !== "selected");
    let excelBlob: any = agGridApi.getDataAsExcel({ onlySelected: onlySelected, columnKeys: colums});
    this.apiService.downloadExcel(excelBlob);    
  } 

  generateExcel(metadataList: any, tagsList: any, stages: any): void {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Sheet 1');
    const headers: any = [];
    AppConstants.ImportFileHeaders.forEach(h => {
      headers.push({ header: h, key: h });
    });
    headers.push({ header: "Existing Stages", key: "Existing Stages" });
    headers.push({ header: "Existing MetaData", key: "Existing MetaData" });
    headers.push({ header: "Existing Tags", key: "Existing Tags" });
    worksheet.columns = headers;
    let rowCount = metadataList.length > tagsList.length ? metadataList.length : tagsList.length;
    if (stages.length > rowCount)
      rowCount = stages.length;
    for (let i = 0; i < rowCount; i++) {
      const obj: any = {};
      headers.forEach((h: any) => {
        if (h.key === "Existing Stages" && i < stages.length)
          obj[h.key] = stages[i];
        else if (h.key === "Existing MetaData" && i < metadataList.length)
          obj[h.key] = metadataList[i];
        else if (h.key === "Existing Tags" && i < tagsList.length)
          obj[h.key] = tagsList[i];
        else
          obj[h.key] = null;
      });
      worksheet.addRow(obj);
    }
    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      saveAs(blob, `PCM_${this.getDateTime()}.xlsx`);
    });
  }

  static chunk(list: any[], chunkSize: number): any [][]
  {
    let valueList: any [][] = [];
    for (let i = 0; i < list.length; i += chunkSize) {
       valueList.push(list.slice(i, i + chunkSize));       
    }
    return valueList;
  }

  static *batches(list: any[], batchSize: number): any {
    const it = list[Symbol.iterator]();
    while (true) {
      // this is for the case when batch ends at the end of iterable
      // (we don't want to yield empty batch)
      let {value, done} = it.next();
      if (done) return value;
  
      yield function*() {
        yield value;
        for (let curr = 1; curr < batchSize; curr++) {
          ({value, done} = it.next());
          if (done) return;
  
          yield value;
        }
      }();
      if (done) return value;
    }
  }

   getDateTime() : string {
    let now : any    = new Date(); 
    let year : any   = now.getFullYear();
    let month : any  = now.getMonth()+1; 
    let day     = now.getDate();
    let hour    = now.getHours();
    let minute  = now.getMinutes();
    let second  = now.getSeconds(); 
    if(month.toString().length == 1) {
         month = '0'+month;
    }
    if(day.toString().length == 1) {
         day = '0'+day;
    }   
    if(hour.toString().length == 1) {
         hour = '0'+hour;
    }
    if(minute.toString().length == 1) {
         minute = '0'+minute;
    }
    if(second.toString().length == 1) {
         second = '0'+second;
    }   
    let dateTime = year+'_'+month+'_'+day+' '+hour+'_'+minute+'_'+second;  
     return dateTime;
  }

  getDate(): string {
    let now: any = new Date(); 
    let year: any = now.getFullYear();
    let month: any = now.getMonth()+1; 
    let day = now.getDate();
    if (month.toString().length == 1) {
         month = '0'+month;
    }
    if (day.toString().length == 1) {
         day = '0'+day;
    }   
    let date = `${month}/${day}/${year}`;  
     return date;
  }

  getGUID(): string {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      var r = Math.random() * 16 | 0,
        v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }
  
  static groupBy(array: any[] , f: any )
  {
    var groups: any = {};
    array.forEach( function( o )
    {
      var group: any = JSON.stringify( f(o) );
      groups[group] = groups[group] || [];
      groups[group].push( o );  
    });
    return Object.keys(groups).map( function( group )
    {
      return groups[group]; 
    })
  }
}